export default __webpack_public_path__ + "static/media/623.908d6f33.png";